import dayjs from "dayjs";
import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import { toFixed2, toNumber } from "../components/exportUtils";

const money = (key) => ({ render: (row) => CurrencyFormatter(toNumber(row?.[key])), exportValue: (row) => toFixed2(row?.[key]) });
const due = (row) => toNumber(row?.total) - toNumber(row?.paid_amount);

const columns = [
    { key: "date", label: "Date", primary: true, render: (row) => dayjs(row?.date).format("DD/MM/YYYY"), exportValue: (row) => dayjs(row?.date).format("DD/MM/YYYY") },
    { key: "orders", label: "Orders", align: "right" },
    { key: "delivered", label: "Delivered", align: "right" },
    { key: "items_total", label: "Items", align: "right", ...money("items_total") },
    { key: "delivery_total", label: "Delivery Charges", align: "right", ...money("delivery_total") },
    { key: "total", label: "Total Sales", align: "right", ...money("total") },
    { key: "paid_amount", label: "Paid", align: "right", ...money("paid_amount") },
    { key: "due", label: "Due", align: "right", render: (row) => CurrencyFormatter(due(row)), exportValue: (row) => due(row).toFixed(2) },
];

// Shop orders and revenue per day (cancelled orders left out)
const ShopSalesReport = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Shop Sales", websiteData);

    const report = useServerReport("report/shop-sales");

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Shop Sales" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Shop Sales Report" filename="shop-sales-report" searchPlaceholder="Search" />
            <ReportTable report={report} columns={columns} />
        </div>
    </div>);
};

export default withAdminAuth(ShopSalesReport);
